module.exports = __webpack_public_path__ + "static/img/200295.3d39cac0.png";